export default __webpack_public_path__ + "3189102.png";